export const environment = {
  production: false,
  apiUrl: 'https://api.transformer.platform.dev.transflo.com/api/v1',
};
